import { Button, Col, Row, Space, Typography, List, Spin } from 'antd'
import { alphabeticalSort } from 'shared'
import NotGuaranteed from '../NotGuaranteed'
import { GenericQueueProps } from './types'
import GenericRequestCard from './components/GenericRequestCard'
import { GenericRequestFields } from './components/GenericRequestCard/types'

function GenericQueue<T extends GenericRequestFields>({
  active: request,
  queued: { requests, ...queued },
  refetch,
  options,
  fetching = false,
}: GenericQueueProps<T>) {
  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Space direction="vertical" size="large" style={{ width: '50%' }}>
        <Typography.Text>
          Click the Refresh button below to pull an updated status of the Queue.
        </Typography.Text>
        <Typography.Text>
          Estimated times are set at the time of request and do not account for
          any requests already in the Queue.
        </Typography.Text>
        <NotGuaranteed />
        <Button
          onClick={() => refetch?.()}
          type="primary"
          loading={fetching}
          disabled={fetching}
        >
          Refresh
        </Button>
        {!request && !requests.length && (
          <Typography.Paragraph>
            It doesn't appear any requests are in the Queue at this time.
          </Typography.Paragraph>
        )}
      </Space>
      {(!!request || !!requests.length) && (
        <Spin spinning={fetching}>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              {request && (
                <GenericRequestCard request={request} options={options} />
              )}
            </Col>
            <Col span={12}>
              <List
                style={{
                  maxHeight: '55vh',
                  overflowY: !!requests.length ? 'scroll' : undefined,
                  overflowX: 'hidden',
                }}
                dataSource={requests.sort(alphabeticalSort('createdDate'))}
                grid={{ gutter: 8, column: 1 }}
                renderItem={(request) => (
                  <List.Item style={{ width: '99%' }}>
                    {
                      <GenericRequestCard
                        {...queued}
                        refetch={refetch}
                        request={request}
                        options={options}
                      />
                    }
                  </List.Item>
                )}
                pagination={false}
              />
            </Col>
          </Row>
        </Spin>
      )}
    </Space>
  )
}

export default GenericQueue
